import * as React from 'react';
import { cn } from '@/shared/lib/cn';

export type SuggestionsProps = React.HTMLAttributes<HTMLDivElement>;

/** Linha de chips de resposta rápida — usado pra `clarificationOptions` que a IA propõe. */
export const Suggestions = React.forwardRef<HTMLDivElement, SuggestionsProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-wrap gap-2', className)} {...props} />
  ),
);
Suggestions.displayName = 'Suggestions';

export interface SuggestionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  suggestion: string;
}

export const Suggestion = React.forwardRef<HTMLButtonElement, SuggestionProps>(
  ({ suggestion, className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'rounded-full border border-primary/30 bg-primary/5 px-3.5 py-1.5 text-xs font-medium text-primary',
        'transition-colors duration-150 hover:bg-primary/10 active:scale-[0.98]',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children ?? suggestion}
    </button>
  ),
);
Suggestion.displayName = 'Suggestion';
